<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import type { SharedOrder } from "@shared/types/Order";

  export let SalesRep;
  export let order: SharedOrder;

</script>

{#if order.vacationing_sales_reps.length > 0}
  {#each order.vacationing_sales_reps as rep_vacation}
    <div
      class="background-white padding--small align-left margin-bottom--small"
      ng-repeat="rep_vacation in order.vacationing_sales_reps"
    >
      <div class="default-subheader--bold padding-bottom--smallest">
        <Icon
          className="color-yellow vertical-align-middle"
          width="18"
          height="16"
          type="Warning"
        /> Vacation Alert'
      </div>
      <div class="default-body--regular">{SalesRep.salesRepVacationMessage(rep_vacation)}</div>
    </div>
  {/each}
{/if}
